export const API_ROOT = {
  'development': 'https://api-edge-dev.inherinext.compassbioinfo.com/',
  'production': 'https://server-edge.inherinext.com/'
}[process.env.NODE_ENV]

export const API_ROOT2 = {
  'development': 'https://server.compassbioinfo.com/',
  'production': 'https://server.compassbioinfo.com/'
}[process.env.NODE_ENV]



// WEBPACK FOOTER //
// ./src/api/config.js